import { postRequest } from 'utilities/service.utils';
import LocateService from './locate.service.context';
import createUrlBuilder from 'utilities/url.builder.utils';

export const addEvent = async (params: any) => {
  const data = {
    event_type: params.event_type,
    details: params.details
  };
  const urlBuilder = createUrlBuilder(`/events`).toString();

  return await postRequest(LocateService, urlBuilder, data);
};
